





















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {Grid} from '@toast-ui/vue-grid';
import {Member} from '@/types';
@Component
export default class PageContentBottom extends Vue {
  @State private view!: object;
  private options = {
    rowHeaders: ['checkbox'],
    header: {
      height: 33
    },
    columnOptions: {
      minWidth: 50
    },
    minRowHeight: 31,
    rowHeight: 31,
    bodyHeight: 190,
    isInitialRequest: true,
    keyColumnName: 'memberNo',
    useClientSort: false,
    pageOptions: {
      perPage: 1,
      page: 1,
      totalCount: 1
    },
    myTheme: {
      name: 'myTheme',
      value: {
        cell: {
          header: {
            background: '#e5e5e5',
            border: '#ccc'
          },
          editable: {
            background: '#fff',
            border: '#ccc'
          }
        }
      }
    }
  };
  private myLang = {
    name: 'ko',
    value: {
      display: {
        noData: '조회 결과가 없습니다.'
      }
    }
  };
  @Prop({required: true}) readonly gridProps!: object;
  @Prop({required: true}) readonly data!: Member[];
  @Watch('data')
  onDataChanged() {
    (this.$refs.tuiGrid as Grid).invoke('resetData', this.data as any);
  }
  private mounted() {
    (this.$refs.tuiGrid as Grid).invoke('setBodyHeight', this.data.length != 0 ? 190 : 480);

    var pagination = (this.$refs.tuiGrid as Grid).invoke('getPagination');
    if (pagination != null) {
      pagination.on('beforeMove', () => {
        this.$emit('searchBtnClick');
      });

      pagination.on('afterMove', () => {
        this.$emit('searchBtnClick');
      });
    }
  }
}
